import { render, staticRenderFns } from "./ListAside.vue?vue&type=template&id=a7bc778c&scoped=true"
import script from "./ListAside.ts?vue&type=script&lang=ts&external"
export * from "./ListAside.ts?vue&type=script&lang=ts&external"
import style0 from "./ListAside.vue?vue&type=style&index=0&id=a7bc778c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bc778c",
  null
  
)

export default component.exports